export const environment = {
  production: false,
  url: '',
  ApiUrl: 'https://thfcbapidev.clavisco.com/api/',
  AzureUrl: 'https://clvsappsdev.blob.core.windows.net',
  env: 'Development',
};
